'use client'

import { siteConfig } from '@/config/site'
import { useEffect } from 'react'

export default function DynamicFavicon() {
  useEffect(() => {
    try {
      const { hostname } = window.location
      const domain = hostname.match(/[^.]+\.[^.]+$/)?.[0]
      const assetUrl = siteConfig.isDynamicDomain
        ? `https://images.${domain}/web`
        : `https://images.mfans.live/web`

      // 選擇現有的 favicon 連結或創建一個新的
      let faviconLink = document.querySelector(
        'link[rel="icon"]',
      ) as HTMLLinkElement | null
      if (!faviconLink) {
        faviconLink = document.createElement('link')
        faviconLink.rel = 'icon'
        document.head.appendChild(faviconLink)
      }

      // 更新 favicon URL
      faviconLink.href = `${assetUrl}/favicon.ico`
    } catch (e) {
      console.error('Error updating favicon:', e)
    }
  }, [])

  return null
}
